import AbstractProblem from './abstractProblem';

/**
 * @class Error
 * @extends AbstractProblem
 */
export default class Error extends AbstractProblem {}
